import type { DecoratedProduct } from '~/utils/shop/DecoratedProduct';

/** Minimal breadcrumb shape the function actually reads. */
type BreadcrumbLike = { text?: string | null | undefined };

/**
 * Category labels for GA4 `item_category*` fields. Prefers server-resolved
 * breadcrumbs when present; otherwise uses Magento category names directly so
 * analytics never triggers client-side `slugById` lookups.
 */
export function getAnalyticsCategoryTexts(
  decoratedProduct: DecoratedProduct,
  resolvedBreadcrumbs?: BreadcrumbLike[]
): string[] {
  if (resolvedBreadcrumbs?.length) {
    return resolvedBreadcrumbs.map((item) => item.text ?? '');
  }

  const fromCategories =
    decoratedProduct.categories
      ?.map((category) => category?.breadcrumb_name ?? category?.name ?? '')
      .filter((text): text is string => text.length > 0) ?? [];

  if (fromCategories.length > 0) {
    return fromCategories;
  }

  return decoratedProduct.category ? [decoratedProduct.category] : [];
}
